export default "__VITE_ASSET__CrNxT7pP__"